import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { locationContext } from '../Context/CustomContext';

export const useLocationContext = () => {
  const location = useLocation();
  const {currentLocation,setCurrentLocation } = useContext(locationContext);


  useEffect(() => {
    setCurrentLocation(location.pathname);
    
  }, [location.pathname,setCurrentLocation,currentLocation]);

  return currentLocation;
}
